/**
 * Deterministic stagger (ms) for the idle-float tile bob so neighbouring
 * tiles don't all peak at the same frame. Pure function — lives outside
 * GameScene so it can be unit-tested without a Phaser runtime.
 */
export function computeIdleStagger(row: number, col: number, cols: number, cycleMs: number = 800): number {
  const positional = (row * cols + col) * 80;
  return ((positional % cycleMs) + cycleMs) % cycleMs;
}
